import { Link } from "react-router-dom";
import type { Article } from "@/lib/articles";
import { allCategories, getLatestByCategory } from "@/lib/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function LatestNews() {
  return (
    <div className="w-full space-y-12">
      {allCategories.map((category) => {
        const items = getLatestByCategory(category.id, 3);
        return (
          <section key={category.id} className="w-full">
            <div className="mb-5 flex items-end justify-between border-b border-background-200 pb-3">
              <div className="flex items-center gap-2.5">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${category.icon} text-lg`}></i>
                </span>
                <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {category.name} · 最新资讯
                </h2>
              </div>
              <Link
                to={`/category/${category.id}`}
                className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                查看更多
                <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {items.map((article: Article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}